import { z } from 'zod';

/**
 * Backend accepts 'test' | 'prod' | 'live' and normalizes 'live' → 'prod'.
 * Mirror that on the client so URL params like `?mode=live` still work.
 */
export const modeSchema = z
  .enum(['test', 'prod', 'live'])
  .transform((v) => (v === 'live' ? 'prod' : v));

export type ModeInput = z.input<typeof modeSchema>;
